import { Node } from '@tiptap/core';

// Explicit page break. Two consumers read it: DocumentTemplateServices::BackgroundPages
// splits the document on it so each page gets its own background art, and wkhtmltopdf
// honours the inline `page-break-before` for documents without art.
export const PageBreak = Node.create({
  name: 'pageBreak',
  group: 'block',
  atom: true,
  selectable: true,

  parseHTML() {
    return [{ tag: 'div[data-page-break]' }];
  },

  renderHTML() {
    return ['div', {
      'data-page-break': 'true',
      class: 'tr-editor__page-break',
      style: 'page-break-before: always'
    }];
  },

  addCommands() {
    return {
      setPageBreak: () => ({ commands }) => commands.insertContent({ type: this.name })
    };
  }
});
